// extracted by css-extract-rspack-plugin
export default {"cls1":"SidebarComments-cls1_WM3","cls2":"SidebarComments-cls2_dAD SidebarComments-cls1_WM3"};